import { useMemo } from 'react';
import { Image, ROW_HEADERS, RowHeader, TableRowData } from './types';

const useTableData = (newImage: Image, duplicateImages: Image[]): TableRowData[] => {
  const imageAttributes = (header: RowHeader, image: Image): string => {
    switch (header) {
      case 'imageData':
        return image.imageUrl;
      case 'fileName':
        return image.fileName;
      case 'dimensions':
        return image.resolution || 'N/A';
      case 'size':
        return image.fileSize || 'N/A';
      case 'credits':
        return image.credits || 'N/A';
      case 'englishImageOnly':
        return image.englishImageOnly ? 'Yes' : 'No';
      case 'numberOfUses':
        return image.numberOfUses?.toString() || '0';
      case 'altText':
        return image.descriptionEn || 'N/A';
      case 'useAsPrimary':
      case 'license':
        return '';
      default:
        return '';
    }
  };

  return useMemo(() => (
    ROW_HEADERS.map((header, index) => ({
      duplicateImages: duplicateImages.map(image => imageAttributes(header, image)),
      header,
      id: `row-${index}`,
      uploadedImage: imageAttributes(header, newImage),
    }))
  ), [newImage, duplicateImages]);
};

export default useTableData;
